import React from "react";
import { connect } from "react-redux";
import Loader from "react-loader-spinner";
import PropTypes from 'prop-types';

import Header from './Header';
import MainContent from './MainContent';
import Sidebar from './Sidebar';

import ForbiddenPage from "../pages/ForbiddenPage";

import { UserRole, checkUserRole } from "../../helpers/userActivity";

/**
 * Layout administratora - zawiera wszystkie komponenty layoutu
 * 
 * Loader dopóki nie ma załadowanego użytkownika - authenticatedUser - co zapewnia że komponenty privtae mają zawsze użytkownika załadowanego
 *
 * @param {Node} children
 * @param {Array} rest - pozostałe parametry np formatMessage, authenticated, authenticatedUser 
 */
const AdminLayout = ({ children, content: Content, props,  ...rest }) => {

    return (
        <div className="privateLayout">
            <Header {...rest} />
            <Sidebar />

            <Content className="leftSidebar" {...rest}> {children}</Content>

            {/*
            <MainContent className="leftSidebar">
                {children}
            </MainContent>
*/}
        </div>
    )
}

// Definiuje domyślne wartości dla właściwości:
AdminLayout.defaultProps = {
    content: MainContent
};

AdminLayout.propTypes = {
    content: PropTypes.elementType
};

/**
 * Layout Manager/Serwis - zawiera komponenty layoutu, za wyjatkiem sidebar - bocznego menu
 */
const ManagerLayout = ({ children, ...rest }) => {
    return (
        <div className="privateLayout">
            <Header {...rest} />
            <MainContent>
                {children}
            </MainContent>
        </div>
    )
}

/**
 * Layout prywatnych stron, wymagajacych autoryzacji
 */
class PrivateLayout extends React.Component {

    state = {
        //pokazujemy loader dopóki nie uzyskamy calego modelu uzytkownika
        loading: true
    }

    componentDidMount() {

        //aktualizujemy przy montowaniu jesli mamy juz uzytkownika 
        if (this.props.authenticatedUser) {
            this.setState({ loading: false });
        }

    }

    componentDidUpdate(prevProps, prevState) {

        //aktualizujemy tylko wtedy kiedy zmienil sie stan zalogowanego uzytkownika (z null na obiekt)
        if (prevProps.authenticatedUser !== this.props.authenticatedUser) {
            if (this.props.authenticatedUser) {
                this.setState({ loading: false });
            }
        }
    }

    render() {

        if (this.state.loading) {
            return <div className="w3-container w3-center">
                <Loader type="ThreeDots" color="#1797be" height={100} width={100} />
            </div>
        }

        //czy uzytkownik ma role admina
        const hasRoleAdmin = checkUserRole(this.props.authenticatedUser, UserRole.ROLE_ADMIN);
        //czy uzytkownik ma role manager
        const hasRoleManager = checkUserRole(this.props.authenticatedUser, UserRole.ROLE_MANAGER);
        //czy uzytkownik ma role serwis
        const hasRoleServis = checkUserRole(this.props.authenticatedUser, UserRole.ROLE_SERVICE);

        if (hasRoleAdmin) {
            return <AdminLayout {...this.props}>{this.props.children}</AdminLayout>
        }
        if (hasRoleManager) {
            return <ManagerLayout {...this.props}>{this.props.children}</ManagerLayout>
        }
        if (hasRoleServis) {
            return <ManagerLayout {...this.props}>{this.props.children}</ManagerLayout>
        }

        return <ForbiddenPage />;

    }

}

const mapStateToProps = state => ({
    authenticated: state.authReducer.authenticated,
    authenticatedUser: state.authReducer.authenticatedUser
})

export default connect(
    mapStateToProps
)(PrivateLayout);
